import columns from '../../../../../react-table/helpers/columns';
import { sumTotal, sumTotalSecond } from '../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
    NonZeroNumberSecondColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('User ID', 'userId').withTotalHeader('Total'),
        new TextColumn('User name', 'userName'),
        new TextColumn('Operator', 'operator'),
        new TextColumn('Report ID', 'reportNo'),
        new TextColumn('Report', 'reportName'),
        new DateTimeColumn('Report generation date', 'reportGenerationDate'),
        new NonZeroNumberSecondColumn('Duration(seconds)', 'duration').withTotalHeader(sumTotalSecond),
        new NonZeroNumberColumn('Rows', 'queries').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Days selected', 'daysSelected'),
        new DateTimeColumn('Period from', 'periodFrom'),
        new DateTimeColumn('Period to', 'periodTo'),
      ],
    },
  ];
};
